exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".LoginForm__wrapper___3lnNt {\n    height: 100vh;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    background: rgba(0,0,0,0.1) url(" + require("../../assets/img/home-bg.jpg") + ") top center no-repeat;\n    background-size: cover;\n    color: white;\n    text-align: center;\n}\n\n.LoginForm__form___2g3u6 {\n    max-width: 300px;\n    width: 300px;\n    margin-top: 60px;\n}\n\n.LoginForm__form___2g3u6 input {\n    border-bottom: 0;\n    border-radius: 0;\n}\n\n.LoginForm__form___2g3u6 input:focus {\n    border: 1px solid #ced4da;\n    border-bottom: 0;\n}\n\n.LoginForm__form___2g3u6 a {\n    display: block;\n    width: 100%;\n    text-align: center;\n}\n\n.LoginForm__form___2g3u6 .LoginForm__formGroup___3CG0M {\n    margin: 0 !important;\n}\n\n.LoginForm__btnRegister___ebRMl {\n    margin-top: 40px;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "LoginForm__wrapper___3lnNt",
	"form": "LoginForm__form___2g3u6",
	"formGroup": "LoginForm__formGroup___3CG0M",
	"btnRegister": "LoginForm__btnRegister___ebRMl"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/LoginForm/LoginForm.css
// module id = 465
// module chunks = 0